// extracted by mini-css-extract-plugin
export default {"spacer":"spacer___EBDX1","hidden":"hidden___TVkoX"};